import './_collection-related-tags.scss';

export default () => {};
